export enum DISCOUNT_UNIT {
  PERCENTAGE = "PERCENTAGE",
  FIXED = "FIXED",
}
